import { loadable } from "components/SpruceLoader";

export const Distro = loadable(() => import("./distroSettings/index"));
